export default "__VITE_ASSET__0SwkOBpy__"